import useHasMounted from '@/hooks/useHasMounted';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import Link from 'next/link';

// Heads up: We’re doing scheduled site maintenance for the next few hours. We’ll be back online soon!
// We're experiencing higher than normal traffic. Please hang tight while we work on scaling our systems.

const bannerStateVersion = 22;

export const bannerAtom = atomWithStorage(
  `bannerState${bannerStateVersion}`,
  true,
);

const Banner = () => {
  const [showBanner, setShowBanner] = useAtom(bannerAtom);
  const hasMounted = useHasMounted();

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner || !hasMounted) return null;

  return (
    <div className="left-0 top-0 sticky w-full text-center h-9 max-sm:text-xs text-badgeBlue text-sm font-semibold bg-badgeLightBlue p-2 z-[49] flex justify-between items-center">
      <div className="text-center flex-grow">
        <span>
          {/* We're investigating an outage with one of our core service providers.
          Some features might be unavailable. */}
          Introducing Table View.{' '}
          <Link className="underline" href="/blog/introducing-table-view">
            Learn more
          </Link>
          .
        </span>
      </div>
      <button
        onClick={handleClose}
        className="bg-transparent border-none cursor-pointer p-2 text-xl font-medium"
      >
        &times;
      </button>
    </div>
  );
};

export default Banner;
